<script lang="ts">
  import { Tooltip, type TooltipTriggerProps } from "#lib/internal/components"
  import type { Snippet } from "svelte"
  import { getTooltipRootCtx } from "./TooltipRoot.svelte"

  type Props = TooltipTriggerProps & {
    noop?: boolean
    children?: Snippet
    onclick?: (e: MouseEvent) => void
  }

  let { noop = false, children, onclick, ...restProps }: Props = $props()

  const rootCtx = getTooltipRootCtx()

  function handleClick(e: MouseEvent) {
    if (!noop) $rootCtx.open = true
    onclick?.(e)
  }
</script>

<Tooltip.Trigger type="button" onclick={handleClick} {...restProps}>
  {@render children?.()}
</Tooltip.Trigger>
